import { BaseNutritionItem, NutritionSection } from './types';

export type Micronutrient = BaseNutritionItem;

export const getSpotlightData = (
  t: (key: string, options?: Record<string, unknown>) => string
): NutritionSection => ({
  sectionTitle: t('food.info.spotlight.sectionTitle'),
  notes: t('food.info.spotlight.notes'),
  items: [
    {
      component: t('food.info.spotlight.items.vitaminD.component'),
      summary: t('food.info.spotlight.items.vitaminD.summary'),
      role: t('food.info.spotlight.items.vitaminD.role'),
      sources: t('food.info.spotlight.items.vitaminD.sources'),
    },
    {
      component: t('food.info.spotlight.items.iron.component'),
      summary: t('food.info.spotlight.items.iron.summary'),
      role: t('food.info.spotlight.items.iron.role'),
      sources: t('food.info.spotlight.items.iron.sources'),
    },
    {
      component: t('food.info.spotlight.items.magnesium.component'),
      summary: t('food.info.spotlight.items.magnesium.summary'),
      role: t('food.info.spotlight.items.magnesium.role'),
      sources: t('food.info.spotlight.items.magnesium.sources'),
    },
    {
      component: t('food.info.spotlight.items.bVitamins.component'),
      summary: t('food.info.spotlight.items.bVitamins.summary'),
      role: t('food.info.spotlight.items.bVitamins.role'),
      sources: t('food.info.spotlight.items.bVitamins.sources'),
    },
    {
      component: t('food.info.spotlight.items.zinc.component'),
      summary: t('food.info.spotlight.items.zinc.summary'),
      role: t('food.info.spotlight.items.zinc.role'),
      sources: t('food.info.spotlight.items.zinc.sources'),
    },
    {
      component: t('food.info.spotlight.items.electrolytes.component'),
      summary: t('food.info.spotlight.items.electrolytes.summary'),
      role: t('food.info.spotlight.items.electrolytes.role'),
      sources: t('food.info.spotlight.items.electrolytes.sources'),
    },
  ],
});

export const getExtendedData = (
  t: (key: string, options?: Record<string, unknown>) => string
): NutritionSection => ({
  sectionTitle: t('food.info.extended.sectionTitle'),
  notes: t('food.info.extended.notes'),
  items: [
    {
      component: t('food.info.extended.items.vitaminD.component'),
      summary: t('food.info.extended.items.vitaminD.summary'),
      role: t('food.info.extended.items.vitaminD.role'),
      sources: t('food.info.extended.items.vitaminD.sources'),
    },
    {
      component: t('food.info.extended.items.bVitamins.component'),
      summary: t('food.info.extended.items.bVitamins.summary'),
      role: t('food.info.extended.items.bVitamins.role'),
      sources: t('food.info.extended.items.bVitamins.sources'),
    },
    {
      component: t('food.info.extended.items.vitaminC.component'),
      summary: t('food.info.extended.items.vitaminC.summary'),
      role: t('food.info.extended.items.vitaminC.role'),
      sources: t('food.info.extended.items.vitaminC.sources'),
    },
    {
      component: t('food.info.extended.items.iron.component'),
      summary: t('food.info.extended.items.iron.summary'),
      role: t('food.info.extended.items.iron.role'),
      sources: t('food.info.extended.items.iron.sources'),
    },
    {
      component: t('food.info.extended.items.magnesium.component'),
      summary: t('food.info.extended.items.magnesium.summary'),
      role: t('food.info.extended.items.magnesium.role'),
      sources: t('food.info.extended.items.magnesium.sources'),
    },
    {
      component: t('food.info.extended.items.calcium.component'),
      summary: t('food.info.extended.items.calcium.summary'),
      role: t('food.info.extended.items.calcium.role'),
      sources: t('food.info.extended.items.calcium.sources'),
    },
    {
      component: t('food.info.extended.items.zinc.component'),
      summary: t('food.info.extended.items.zinc.summary'),
      role: t('food.info.extended.items.zinc.role'),
      sources: t('food.info.extended.items.zinc.sources'),
    },
    {
      component: t('food.info.extended.items.electrolytes.component'),
      summary: t('food.info.extended.items.electrolytes.summary'),
      role: t('food.info.extended.items.electrolytes.role'),
      sources: t('food.info.extended.items.electrolytes.sources'),
    },
  ],
});